import "./App.css";
import {
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Header2026 from "./components/Header2026/Header";
import Sections from "./components/Sections/Sections";
import Footer from "./components/Footer/Footer";

import "./i18n/i18n";
import CustomForm from "./components/CustomForm/CustomForm";

function App() {
  const location = useLocation(); // Get current route location

  const isContactPage = location.pathname === "/contact";

  return (
    <div className="App">
      <div className="header-navbar-wrapper">
        {!isContactPage && <Header2026 />}
      </div>

      <div className="sections-footer-wrapper">
        <Routes>
          <Route path="/contact" element={<CustomForm />} />
          <Route path="/" element={<Sections />} />
        </Routes>

        {!isContactPage && <Footer />}
      </div>
    </div>
  );
}

export default App;
